'use client'

import { useEffect } from 'react'
import ReferralFormNew from '@/components/molecules/Referral/ReferandEarn/ReferralFormNew'
import RefferalBannerImage from '../../../../../../../public/referral/dashboard/icons/referearbox.webp'
import boxImage from '../../../../../../../public/referral/dashboard/icons/box.webp'
import tickYellowSvg from '../../../../../../../public/referral/dashboard/icons/TickSvg.svg'

const ReferralBulletPoints = [
  'Earn up to ₹5,000 for every successful referral.',
  'Unlock exclusive badges',
  'Access VIP campus experiences',
]

export default function ReferralModal({ onClose,programs }: { onClose: () => void; programs?: any }) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKey)

    // Lock body scroll while the modal is open. `overflow: hidden` alone
    // doesn't work on iOS Safari — the page still scrolls — so we also
    // pin the body with `position: fixed` and restore the scroll
    // position on close.
    const scrollY = window.scrollY || document.documentElement.scrollTop
    const prev = {
      overflow: document.body.style.overflow,
      position: document.body.style.position,
      top: document.body.style.top,
      left: document.body.style.left,
      right: document.body.style.right,
      width: document.body.style.width,
    }
    document.body.style.overflow = 'hidden'
    document.body.style.position = 'fixed'
    document.body.style.top = `-${scrollY}px`
    document.body.style.left = '0'
    document.body.style.right = '0'
    document.body.style.width = '100%'

    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = prev.overflow
      document.body.style.position = prev.position
      document.body.style.top = prev.top
      document.body.style.left = prev.left
      document.body.style.right = prev.right
      document.body.style.width = prev.width
      // Restore scroll without smooth-scroll jumping.
      const prevScrollBehavior = document.documentElement.style.scrollBehavior
      document.documentElement.style.scrollBehavior = 'auto'
      window.scrollTo(0, scrollY)
      document.documentElement.style.scrollBehavior = prevScrollBehavior
    }
  }, [onClose])

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/60 p-4">
      <div className="relative flex w-full max-w-[950px] sm:flex-col overflow-hidden rounded-[24px] bg-white shadow-[0_30px_80px_rgba(0,0,0,0.4)] md:flex-row">
        <button
          type="button"
          aria-label="Close"
          onClick={onClose}
          className="absolute right-4 top-2 z-[2] flex h-8 w-8 items-center justify-center rounded-full sm:text-white  text-[#16285C] transition-colors hover:bg-black/5"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M6 6l12 12M18 6L6 18"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
            />
          </svg>
        </button>

        {/* LEFT: promo image */}
        <div
          className="relative w-full sm:p-3 p-4 shrink-0 overflow-hidden lg:w-[44%] text-center flex flex-col items-start"
          style={{
            background: "linear-gradient(135deg, #001B45 70%, #0f7dea60)",
          }}
        >
          <span className="inline-block text-white font-bold text-3xl px-1 pt-4 sm:text-[1.3rem]">
            Join The Amity Online
          </span>
          <span className="text-[#FFC107] font-bold lg:mt-2 text-3xl sm:text-[1.3rem]">
            Ambassadors Program
          </span>
          {ReferralBulletPoints.map((point) => {
            return (
              <div
                key={point}
                className="flex items-center gap-2 sm:mt-2 mt-4 "
              >
                <img
                  src={tickYellowSvg.src}
                  alt="Checkmark"
                  className="h-5 w-5 sm:h-3 sm:w-3 shrink-0"
                />
                <p className="text-white sm:text-xs lg:text-[14px]">{point}</p>
              </div>
            );
          })}
          <img
            src={RefferalBannerImage.src}
            alt="Join the Amity Online Ambassadors Program"
            className="absolute w-44 h-36 bottom-0 sm:right-0 sm:w-24 sm:h-16 opacity-90"
          />
          <img
            src={boxImage.src}
            alt="Join the Amity Online Ambassadors Program"
            className="absolute bottom-5 right-0 sm:hidden"
          />
        </div>

        {/* RIGHT: form */}
        <div className="w-full lg:w-[56%]">
          <ReferralFormNew programs={programs} />
        </div>
      </div>
    </div>
  );
}
